const config = require('@/config/config')
const { products, plans } = require('@/data/planData')

let stripeIds
if (config.ENV === 'development' || config.ENV === 'alpha') stripeIds = require('@/data/devStripeIds').default
else stripeIds = require('@/data/prodStripeIds').default

Object.keys(products).forEach(productId => {
  // Setup stripe product and plan ids, and plan dictionary:
  products[productId].stripeId = stripeIds.products[productId]
  Object.values(products[productId].plans).forEach(plan => {
    plan.stripeId = stripeIds.plans[plan.id]
  })
})

Object.keys(plans).forEach(planId => {
  plans[planId].stripeId = stripeIds.plans[planId]
})

const paidFeatures = {
  '5-projects': { label: '5 projects' },
  'free-qrs-limit': { label: '1 Dynamic QR code' },
  'free-projects-limit': { label: '1 Microsite' },
  '1k-views-100-leads': { label: '1k views, 100 leads' },
  'free-emails-limit': { label: '100 Emails', action: 'capture more emails' },
  'experience-builder': { label: '', action: 'create and publish experiences' },

  'realtime-reporting': { label: '' },
  'branded-endplate': { label: '' },
  'faraday-badge': { label: '' },
  'email-capture': { label: '', action: 'unlock email capture widgets' },
  'customer-crm': { label: '' },
  'ad-pairing': { label: 'Audience builder', action: 'publish a social ad campaign' },

  // new paid features
  'custom-unfurl-image': { label: '', action: 'set custom unfurl image' },
  'custom-license': { label: '', action: 'set custom license link' },
  '20-projects': { label: '10 Microsites', action: 'create more Microsites' },
  'grow-projects-limit': { label: '10 Microsites', action: 'create more Microsites' },
  'grow-qrs-limit': { label: '10 Dynamic QR codes' },
  '100k-views-1k-leads': { label: '100k views, 1k leads' },
  'grow-emails-limit': { label: '1000 Emails', action: 'capture more emails' },
  placements: { label: '', actions: 'Export Placements' },

  'unlimited-views': { label: 'Unlimited views' },
  'unlimited-leads': { label: 'Unlimited leads' },
  'unlimited-projects': { label: 'Unlimited projects', action: 'create more projects', altAction: 'creating more than 20 projects' },
  'pro-projects-limit': { label: 'Unlimited projects', action: 'create more projects', altAction: 'creating more projects' },
  'pro-emails-limit': { label: 'X Emails', action: 'capture more emails' },

  'multiple-users': { label: 'Multiple users' },
  'unlimited-subdomains': { label: 'Unlimited subdomains' },
  '3-custom-domains': { label: '3 custom domains' },
  'coaching-and-ac-management': { label: 'Coaching and account management' },

  'single-user': { label: 'Single user' },
  // Updated Microsite Studio Features
  'microsite-studio-access': { label: 'Microsite studio' },
  'single-page-microsite': { label: 'Single-page Microsites' },
  'multi-page-microsite': {
    label: 'Multi-page Microsites',
    action: 'create tappable stories',
    customPaywall: true,
    features: [
      'Single + multi-page Microsites',
      'All Microsite widgets',
      'Smart integrations',
      'Brand fonts + meta data'
    ],
    upgradeTo: 'Upgrade to unlock multi-page Microsites and widget features',
    paywallTitle: 'Tappable Stories'
  },
  'interactive-widgets': { label: 'All Microsite widgets' },
  'smart-result-frames': { label: 'Smart result frames' },
  'custom-url': { label: 'Custom Microsite URL' },
  'custom-domain-hosting': { label: 'Custom domains' },
  'custom-templates': {
    label: 'Designer templates',
    action: 'create tappable stories',
    customPaywall: true,
    features: [
      'Single + multi-page Microsites',
      'All Microsite widgets',
      'Smart integrations',
      'Brand fonts + meta data'
    ],
    upgradeTo: 'Upgrade to unlock designer templates and powerful brand features',
    paywallTitle: 'Designer Templates'
  },
  'custom-fonts': { label: 'Custom fonts' },
  'custom-meta-data': { label: 'Custom meta data' },
  'flow-analytics': { label: 'Detailed analytics' },
  'view-raw-data': { label: 'Raw data views' },

  // Updated QR Studio Features
  'qr-code-studio-acess': { label: 'Dynamic QR Studio' },
  'dynamic-qrs': {
    label: 'Dynamic QR codes',
    action: 'create Dynamic QR codes',
    customPaywall: true,
    features: [
      'Branded QR codes',
      'Real-time analytics',
      'Transport customers online',
      'Pair with Microsites'
    ],
    upgradeTo: 'Upgrade to design, manage and track QR code campaigns',
    paywallTitle: 'Create QR Codes'
  },
  'pro-qrs-limit': { label: 'Unlimited Dynamic QR codes' },
  'static-qrs': { label: 'Static QR codes' },
  'qr-customization': { label: 'QR Code customization' },
  'qr-code-logos': { label: 'QR Code logos' },
  'qr-code-analytics': { label: 'QR Code analytics' },

  // Updated Essentials Features
  integrations: { label: '' },
  'email-integrations': { label: 'Email integrations (Klaviyo, Mailchimp, Hubspot)' },
  'fb-pixel': { label: 'FB Pixel Integration' },
  zapier: { label: 'Webhooks (Zapier)' },
  'remove-faraday-branding': { label: 'Remove Tapkit Branding' },
  spport: { label: 'Email support' },

  // Update premium features
  '10-plus-users': { label: 'Teams 10+ users' },
  'teams-and-permissions': { label: 'Team sharing and permissions' },
  'mfa-logins': { label: 'MFA Secure log-ins' },
  'custom-billing': { label: 'Custom billing' },
  'agency-management': { label: 'Agency project management' },
  'dedicated-account-management': { label: 'Dedicated account manager' },
  coaching: { label: 'Bookable coaching sessions' }

}

const shopifyFeatures = {
  ...products.pro.features,
  shopify: true
}

const enterpriseFeatures = {
  'experience-builder': true,
  'customer-crm': true,
  'ad-pairing': true
}

const walletOrder = [
  'free',
  'grow',
  'pro',
  'business',
  'premium'
]

const enterpriseWalletOrder = [
  'free',
  'base-premium'
]

export {
  products,
  plans,
  paidFeatures,
  shopifyFeatures,
  enterpriseFeatures,
  walletOrder,
  enterpriseWalletOrder
}
